export default "__VITE_ASSET__d4deb981__"